import { Injectable } from '@angular/core';
import { TrayCategoriesItemApiModel, TrayTypeApiModel } from '@cxb/editor-stb-api';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CreateTrayScreenService } from '../create-tray-screen/create-tray-screen.service';
import { filter, map, take } from 'rxjs';
import { refactoredTrays } from './create-tray-srceen-navigation.types';
import { selectCategory, selectTrayType } from '../../create-tray-screen.actions';
import { Store } from '@ngrx/store';
import { RootAppState } from '../../../app.reducer';
import { RouterState } from '@ngrx/router-store';
import { selectTrayOptions } from '../../../app.selectors';

@Injectable()
export class CreateTrayScreenNavigationService {
  constructor(
    private readonly router: Router,
    private readonly createTrayScreenService: CreateTrayScreenService,
    private readonly route: ActivatedRoute,
    private readonly store: Store<RootAppState & RouterState>
  ) {
    this.route.paramMap
      .pipe(map((params: ParamMap) => params.get('pageVersionId')))
      .subscribe((pageVersionId) => (this.pageVersionId = pageVersionId));

    this.trayCategories$
      .pipe(
        filter((trayCategories) => !!trayCategories),
        take(1)
      )
      .subscribe((trayCategories) => {
        this.trayCategories = trayCategories[this.pageType.domainPageType.toLowerCase()];
      });
  }

  public pageType = this.createTrayScreenService.pageType;
  private pageVersionId: string;

  public trayCategories$ = this.store.select(selectTrayOptions);
  public trayCategories: Array<TrayCategoriesItemApiModel>;

  public trayTypeToUrl(trayType: TrayTypeApiModel) {
    return trayType.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (match, isCapital) => (isCapital ? '-' : '') + match.toLowerCase());
  }

  public trayTypeFromUrl(url: string) {
    const camelCase = url.replace(/-./g, (match) => match[1].toUpperCase());
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
  }

  public selectCategoryOfTrayType(trayTypeToFind) {
    return this.trayCategories.find((category) => category.trayTypesInCategory.find((trayType) => trayType.trayType === trayTypeToFind))
      ?.categoryName;
  }

  public storeSelectedValuesFromUrl() {
    const selectedTrayType = TrayTypeApiModel[this.trayTypeFromUrl(this.route.snapshot.url[0].path)];
    //this.store.dispatch(selectCategory({ selectedCategory: this.selectCategoryOfTrayType(selectedTrayType) }));
    this.store.dispatch(
      selectTrayType({
        selectedTrayType,
      })
    );
  }

  public navigateToTrayType(trayType: TrayTypeApiModel) {
    this.router.navigate([this.pageType.routePath, this.pageVersionId, 'tray', this.trayTypeToUrl(trayType)], { relativeTo: this.route });
  }

  public navigateToEditTray(trayToEdit) {
    const { trayType, id } = trayToEdit;

    const selectedTrayCategory = this.trayCategories.find(({ trayTypesInCategory }) =>
      trayTypesInCategory.find(({ name }) => name === trayType)
    );

    const selectedTrayType = selectedTrayCategory.trayTypesInCategory.find(({ name }) => name === trayType).trayType;

    this.router.navigate([this.pageType.routePath, this.pageVersionId, 'edit', this.trayTypeToUrl(selectedTrayType), id]);
  }

  public isTrayRefactored(trayType): boolean {
    return refactoredTrays.includes(trayType);
  }
}
